// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__8Gnup","loadingShrink":"PageLoading_loadingShrink__3RFz5"};